import React, { Component } from "react";
import { Accessor, ZTime } from "IZOX/STATIC";
import PropsType from "prop-types";
import { XText } from "IZOX/_X";
import { observer } from "mobx-react";

/**
 * @augments {Component<Props, State>}
 */
class CountDownLite extends Component {

  static propTypes = {
    onMounted: PropsType.func,
    countDown: PropsType.number,
    refreshRate: PropsType.number,
    onTimeUp: PropsType.func
  }

  static defaultProps = {
    onMounted: null,
    countDown: 60,
    refreshRate: 1000,
    onTimeUp: null
  }

  constructor(props){
    super();
    this.state = {
      lastUpdated: ZTime.Now(),
      nextUpdated: ZTime.Now().add(props.countDown, "seconds")
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.Refresh();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(CountDownLite.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    this.setState = (state, callback) => {
      return;
    };
  }

  Refresh = () => {
    let {nextUpdated} = this.state;
    let {refreshRate, onTimeUp} = this.props;
    let count = ZTime.Difference(ZTime.Now(), nextUpdated, "seconds");
    this.setState({
      now: ZTime.Now(),
      count: count
    }, () => {
      if(this.timeout) clearTimeout(this.timeout);
      if(count <= 0){
        onTimeUp?.();
      }else{
        this.timeout = setTimeout(() => {
          this.Refresh();
        }, refreshRate);
      }
    });
  }

  _setNowAndNext = (nextUpdate, unit) => {
    let now = ZTime.Now();
    let next = ZTime.Add(now, nextUpdate, unit);
    this.setState({
      lastUpdated: now,
      nextUpdated: next
    });
  }

  _setLastUpdated = (date = ZTime.Now()) => {
    this.setState({
      lastUpdated: date
    });
  }

  _setNextUpdated = (nextUpdate, unit) => {
    let now = ZTime.Now();
    let next = ZTime.Add(now, nextUpdate, unit);
    this.setState({
      nextUpdated: next
    });
  }

  _reset = () => {
    let {countDown} = this.props;
    this.setState({
      lastUpdated: ZTime.Now(),
      nextUpdated: ZTime.Now().add(countDown, "seconds")
    });
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), () => {
      this.props.onMounted?.({
        SetNowAndNext: this._setNowAndNext,
        SetLastUpdated: this._setLastUpdated,
        SetNextUpdated: this._setNextUpdated,
        Reset: this._reset
      });
      callback?.();
    });
  }

  render(){
    let {lastUpdated, nextUpdated, count} = this.state;
    if(!lastUpdated && !nextUpdated) return <div/>;
    return (
      <XText bold noWrap>
        {count + " s"}
      </XText>
    );
  }

}

export default observer(CountDownLite);
